import {Button, IconButton, TextareaAutosize, TextField} from "@mui/material"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import {ProjectConfig} from 'Global';
import { useSnackbar, withSnackbar } from "notistack";
import LangTabs from "elements/LangTabs";





  
export default withSnackbar(
  function MaximasEditor(props : any) {

      /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */

  /*=======================================
    GET PROJECT ID AND ESTIMATE ID FROM URL
  =======================================*/
  let {maxima_id } = useParams();
  /*=======================================
  =======================================*/


  const navigate = useNavigate();
  const defaultValues: any = {
    maxima_id: maxima_id? maxima_id : "null",
    content: "",
  };
  
  const [loading, setLoading] = useState(false); 
  const [formValues, setFormValues] = useState(defaultValues);

  // i18n: idioma actual y traducciones
  const [currentLangId, setCurrentLangId] = useState<string>("1");
  const [translations, setTranslations] = useState<Record<string, any>>({});

  // Handler para cambio de idioma
  const handleLangChange = (newLangId: string) => {
    setCurrentLangId(newLangId);
  };

  // Helper para obtener el contenido según idioma
  const getCurrentContent = () => {
    if (currentLangId === "1") return formValues.content || "";
    return translations[currentLangId]?.content || "";
  };

  // Handler para cambio de contenido
  const handleContentChange = (e: { target: { value: any } }) => {
    const value = e.target.value;
    if (currentLangId === "1") {
      setFormValues({ ...formValues, content: value });
    } else {
      setTranslations(prev => ({
        ...prev,
        [currentLangId]: {
          ...prev[currentLangId],
          content: value
        }
      }));
    }
  };




  /*=======================================
    GET DETAILS IF EDITING
  =======================================*/
  useEffect(() => {
    if (maxima_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "maximas_details",
            id: maxima_id,
          },
        })
        .then((response) => {
          console.log("formValues", response.data)
          setFormValues(response.data);
          // Cargar traducciones
          if (response.data.translations) {
            setTranslations(response.data.translations);
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
    }
  }, []);
  /*=======================================
  =======================================*/

  


  /*=======================================
    SUBMIT
  =======================================*/

  const handleSubmit = () => {
    // Preparar formValues con traducciones
    const formValuesWithTranslations = {
      ...formValues,
      translations: translations
    };

    console.log(formValuesWithTranslations);

    //AXIOS
    axios
      .post(ProjectConfig.api_url, null, {
        params: {
          request: "add_edit_maximas",
          formValues: formValuesWithTranslations,
        },
      })
      .then((response) => {
        console.log(response);
        if(response.data){
          navigate("/admin/maximas");
        }else{
          enqueueSnackbar("Error al guardar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
      });


  }
  /*====================================
  =====================================*/







  return (
      <div id="MaximasForm">
        <div className="userForm_right">
          <Box id="maximas_editor" className="box_editor" title="Maximas" subtitle="Editar"  >
            
            {/* Solo mostrar tabs de idioma si estamos editando */}
            {maxima_id && maxima_id !== "null" && (
              <LangTabs 
                currentLangId={currentLangId} 
                onChange={handleLangChange} 
              />
            )}

            <div className='input_group'>
                <div className='input_group'>
                    <div className='input_row'>

                    <TextField 
                        id="content"
                        name="content"
                        label="Contenido"
                        type="text"
                        required={currentLangId === "1"}
                        fullWidth
                        multiline
                        value={getCurrentContent()}
                        onChange={handleContentChange}
                        sx={{ width: '500px' }}
                      />

                  </div>


                </div>


              

            </div>
            <div className='buttons'>
              <Button onClick={() => navigate(-1)} variant="outlined" className="button_2">Cancelar</Button>
              <Button onClick={handleSubmit} variant="contained" className="button_1">Guardar</Button>
            </div>
          </Box>
        </div>

        
          


      </div>
    
  );
})